import { useState } from 'react'

function FormularioHeredero({ onHerederoCreado, userId }) {
  const [nombreCompleto, setNombreCompleto] = useState('')
  const [email, setEmail] = useState('')
  const [rol, setRol] = useState('heir')
  const [nivel, setNivel] = useState('1')
  const [telefono, setTelefono] = useState('')
  const [relacion, setRelacion] = useState('')
  const [notas, setNotas] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setEnviando(true)
    setError('')

    try {
      const respuesta = await fetch('https://legado-digital-production.up.railway.app/api/heirs', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId,
          nombreCompleto,
          email,
          rol,
          nivel: rol === 'confirmer' ? null : nivel,
          telefono,
          relacion,
          notas,
        }),
      })

      const datos = await respuesta.json()

      if (!datos.ok) {
        setError(datos.error || 'Error al añadir persona')
        return
      }

      setNombreCompleto('')
      setEmail('')
      setRol('heir')
      setNivel('1')
      setTelefono('')
      setRelacion('')
      setNotas('')
      onHerederoCreado(datos.datos)

    } catch {
      setError('No se pudo conectar con el servidor')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={estilos.formulario}>
      <h3 style={estilos.titulo}>Añadir a mis personas</h3>

      {error && <div style={estilos.error}>{error}</div>}

      <div style={estilos.grid}>
        <div style={estilos.campo}>
          <label style={estilos.label}>Nombre completo</label>
          <input
            type="text"
            placeholder="Ej: Ana García"
            value={nombreCompleto}
            onChange={e => setNombreCompleto(e.target.value)}
            style={estilos.input}
            required
          />
        </div>

        <div style={estilos.campo}>
          <label style={estilos.label}>Email</label>
          <input
            type="email"
            placeholder="ana@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={estilos.input}
            required
          />
        </div>
      </div>

      <div style={estilos.grid}>
        <div style={estilos.campo}>
          <label style={estilos.label}>Rol</label>
          <select
            value={rol}
            onChange={e => setRol(e.target.value)}
            style={estilos.input}
          >
            <option value="heir">Mi círculo</option>
            <option value="confirmer">Mi guardián</option>
          </select>
        </div>

        {rol === 'heir' && (
          <div style={estilos.campo}>
            <label style={estilos.label}>Nivel de acceso</label>
            <select
              value={nivel}
              onChange={e => setNivel(e.target.value)}
              style={estilos.input}
            >
              <option value="1">Nivel 1 — Suscripciones</option>
              <option value="2">Nivel 2 — Cuentas digitales</option>
              <option value="3">Nivel 3 — Documentos privados</option>
            </select>
          </div>
        )}
      </div>

      <div style={estilos.grid}>
        <div style={estilos.campo}>
          <label style={estilos.label}>Relación</label>
          <input
            type="text"
            placeholder="Ej: pareja, hijo/a, hermano/a"
            value={relacion}
            onChange={e => setRelacion(e.target.value)}
            style={estilos.input}
          />
        </div>

        <div style={estilos.campo}>
          <label style={estilos.label}>Teléfono</label>
          <input
            type="text"
            placeholder="Ej: +34 600 000 000"
            value={telefono}
            onChange={e => setTelefono(e.target.value)}
            style={estilos.input}
          />
        </div>
      </div>

      <div style={estilos.campo}>
        <label style={estilos.label}>Notas privadas</label>
        <input
          type="text"
          placeholder="Instrucciones especiales para esta persona"
          value={notas}
          onChange={e => setNotas(e.target.value)}
          style={estilos.input}
        />
      </div>

      {rol === 'confirmer' && (
        <div style={estilos.aviso}>
          Tu guardián recibirá el aviso del sistema de alerta y activará el acceso
          a tu información cuando sea necesario.
        </div>
      )}

      <div style={{
        backgroundColor: '#FDF0EC', border: '1px solid #F5C9B8',
        borderRadius: '8px', padding: '12px 16px', marginBottom: '12px',
        fontSize: '12px', color: '#5C4033', lineHeight: '1.6'
      }}>
        ⚠️ Al añadir esta persona le enviaremos un email informativo de ETERN-ME.
        <strong> Eres responsable de haber informado previamente a esta persona
        y de haber obtenido su consentimiento</strong> para recibir comunicaciones
        en su nombre.
      </div>

      <button
        type="submit"
        disabled={enviando}
        style={{ ...estilos.boton, opacity: enviando ? 0.7 : 1 }}
      >
        {enviando ? 'Guardando...' : 'Añadir a mis personas'}
      </button>
    </form>
  )
}

const estilos = {
  formulario: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '20px',
    border: '1px solid #e0e0e0',
    marginBottom: '24px',
  },
  titulo: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#1a1a2e',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
  },
  campo: { marginBottom: '14px' },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '500',
    color: '#555',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    fontSize: '14px',
    outline: 'none',
    backgroundColor: '#fff',
  },
  boton: {
    width: '100%',
    padding: '11px',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    marginTop: '4px',
  },
  error: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    padding: '10px 12px',
    borderRadius: '6px',
    fontSize: '13px',
    marginBottom: '14px',
  },
  aviso: {
    backgroundColor: '#fff3cd',
    color: '#856404',
    padding: '10px 12px',
    borderRadius: '6px',
    fontSize: '12px',
    marginBottom: '14px',
    lineHeight: '1.5',
  },
}

export default FormularioHeredero